import { render, staticRenderFns } from "./MobileMain.vue?vue&type=template&id=5d561896&scoped=true&"
import script from "./MobileMain.vue?vue&type=script&lang=js&"
export * from "./MobileMain.vue?vue&type=script&lang=js&"
import style0 from "../MobilePage.scss?vue&type=style&index=0&id=5d561896&scoped=true&lang=scss&"
import style1 from "./MobileMain.scss?vue&type=style&index=1&id=5d561896&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d561896",
  null
  
)

export default component.exports